"use client";

import { Link } from "react-router-dom";
import { useTranslation } from "../hooks/useTranslation";

type LeaguePromoCardProps = {
  isAuthenticated?: boolean;
  onAuthRequired?: () => void;
};

export default function LeaguePromoCard({
  isAuthenticated = false,
  onAuthRequired,
}: LeaguePromoCardProps) {
  const { t } = useTranslation();

  return (
    <Link
      to="/fantasy/leagues"
      onClick={(event) => {
        if (!isAuthenticated && onAuthRequired) {
          event.preventDefault();
          onAuthRequired();
        }
      }}
      className="group block h-full max-h-full w-full min-h-0 rounded-[8px] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FDC300] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--rtbf-blue,#0076A9)]"
    >
      <div
        className="flex h-full max-h-full min-h-0 flex-col overflow-hidden rounded-[8px] bg-[var(--rtbf-blue,#0076A9)] shadow-[0px_5px_15px_0px_rgba(0,0,0,0.10)] transition-shadow group-hover:shadow-[0px_8px_20px_0px_rgba(0,0,0,0.14)]"
      >
        <div className="flex min-h-0 flex-1 flex-col items-center justify-center gap-3 px-4 py-4 text-center sm:gap-4 sm:px-5 sm:py-5">
          <p className="text-[15px] font-semibold leading-snug text-white sm:text-[16px]">
            {t("predictions.leagueCtaTitle")}
          </p>
          <div className="relative inline-flex">
            <span className="inline-flex shrink-0 items-center justify-center rounded-full bg-[#FDC300] px-3.5 py-1.5 text-[11px] font-bold tracking-[0.05em] text-black transition-colors group-hover:bg-yellow-300 sm:px-4 sm:py-1.5 sm:text-xs">
              {t("predictions.leagueCtaButton")}
            </span>
            {!isAuthenticated ? (
              <div className="pointer-events-none absolute bottom-full left-1/2 z-20 mb-1 -translate-x-1/2 opacity-0 transition-opacity duration-150 group-hover:opacity-100 group-focus-visible:opacity-100">
                <div className="rounded-full bg-[var(--rtbf-orange,#fdc300)] px-3 py-1 text-center text-sm font-[700] text-[var(--rtbf-blue-dark,#003e63)] whitespace-nowrap shadow-[0px_4px_10px_rgba(0,0,0,0.20)]">
                  {t("auth.signIn")}
                </div>
                <div className="mx-auto h-0 w-0 border-l-[6px] border-r-[6px] border-t-[6px] border-l-transparent border-r-transparent border-t-[var(--rtbf-orange,#fdc300)]" />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </Link>
  );
}
